<template lang="pug">
div
  v-row.pa-0.ma-0
    h2 Ключевые слова
    v-spacer
    v-btn.mt-2(@click="dialog = true" color="primary") Добавить ключевое слово
  v-row.pa-0.ma-0.mt-4.align-self-center.align-center
    v-text-field(
      filled
      v-model="search"
      label="Поиск по названию"
      hide-details
    )
    v-btn( height=58 color="primary" large @click="getKeyWords(search)") Поиск
    v-btn(height=58 text large @click="reset") сбросить
  v-expansion-panels(v-if="keyWords.length" flat)
    key-word-panel(
      v-for="item in keyWords" :key="item.id"
      :keyWord="item"
      @update="getKeyWords"
    )
  p.mt-2(v-else) Ключевые слова еще не добавленны
  v-pagination(
    v-if="pagination.length > 1"
    color="info"
    v-model="pagination.current"
    :length="pagination.length"
    :total-visible="7"
    @input="getKeyWords()"
  )

  v-dialog(v-model="dialog" max-width="900")
    v-card(dark)
      v-card-title Добавление ключевого слова
      v-card-text
        v-text-field(
            v-model="wordName"
            label="Введите ключевое слово"
        )
      v-card-actions
        v-btn(@click="resetDialogs" color="error") Отмена
        v-spacer
        v-btn.mb-4(@click="createKeyWord" color="success") Сохранить

</template>
<script>
import autoAnswerService from '@/services/API/autoAnswer';
import keyWordPanel from './keyWordPanel.vue';

export default {
  name: 'AutoAnsewerSettings',
  components: {
    keyWordPanel,
  },
  data() {
    return {
      search: null,
      keyWords: [],
      pagination: {
        length: 1,
        current: 1,
      },
      dialog: false,
      loading: true,
      wordName: '',
    };
  },
  async created() {
    this.getKeyWords();
  },
  methods: {
    async getKeyWords(search) {
      try {
        const response = await autoAnswerService.getKeyWords({
          'search[name]': search,
          'page': this.pagination.current,
          'per-page': 20,
          'search[hint_id_assignment]': 1,
          'search[hint]': 3,
        });
        this.pagination.length = +response.headers['x-pagination-page-count'];
        this.keyWords = response.data.data.map((item) => ({ ...item, open: false }));
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },
    reset() {
      this.$emit('search');
      this.search = '';
    },
    resetDialogs() {
      this.dialog = false;
      this.wordName = '';
    },
    async createKeyWord() {
      try {
        const response = await autoAnswerService.createKeyWord({ name: this.wordName });
        this.$toast.success('Успешно созданна');
        this.keyWords.push(response.data.data);
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
      this.resetDialogs();
    },
  },
};
</script>
